import { render, staticRenderFns } from "./TrainingTeam.vue?vue&type=template&id=52ec86b0&scoped=true"
import script from "./TrainingTeam.vue?vue&type=script&lang=js"
export * from "./TrainingTeam.vue?vue&type=script&lang=js"
import style0 from "./TrainingTeam.vue?vue&type=style&index=0&id=52ec86b0&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ec86b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ec86b0')) {
      api.createRecord('52ec86b0', component.options)
    } else {
      api.reload('52ec86b0', component.options)
    }
    module.hot.accept("./TrainingTeam.vue?vue&type=template&id=52ec86b0&scoped=true", function () {
      api.rerender('52ec86b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/training/components/TrainingTeam.vue"
export default component.exports